import request from '@/utils/request'

// 企业列表
export function corpList(params = {}) {
  return request({
    url: '/spWorkWechat/h5/corp/index',
    method: 'get',
    params
  })
}
// 更新企业列表
export function updateList(data) {
  return request({
    url: `/spWorkWechat/h5/corp/update`,
    method: 'post',
    data
  })
}
